export default "__VITE_ASSET__CC0J83WR__"